export default "<span class=\"badge\">\n  {{ value }}\n</span>\n"